import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { useAuth } from '../AuthProvider/AuthProvider';
import { useIsLoginInProgress, useAuthState, useAuthProvider } from '@/store';
import { TokenService } from '../../services/token.service';

export const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const { fallback } = useAuth();
  const location = useLocation();

  const authProvider = useAuthProvider();
  const isSignInLoading = useIsLoginInProgress();
  const { authorized, authChecked } = useAuthState();

  useEffect(() => {
    const tokenInfo = TokenService.get();

    if (tokenInfo && authProvider) {
      const { isExpired, isRefreshing } = tokenInfo;

      if (isExpired && !isRefreshing) {
        authProvider.onRefresh(tokenInfo);
      }
    }
  }, [location, authProvider]);

  useEffect(() => {
    if (!authorized && authProvider) {
      authChecked ? void authProvider.onLogOut() : void authProvider.onLogin();
    }
  }, [authChecked, authorized, authProvider]);

  if (isSignInLoading || !authorized) {
    return fallback ?? null;
  }

  return children;
};
